import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-hcc-summary-report-dw",
  templateUrl: "./hcc-summary-report-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HccSummaryReportDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.HCC_SUMMARY_DW;
  hideFilters = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID];
}
